/* NewCategoriesSectionMessage.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import React from 'react';
const _ = "._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}";
export const SectionMessageStyle = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_otyrpxbi", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SectionMessageStyle.displayName = 'SectionMessageStyle';
}
const NewCategoriesSectionMessage = () => {
  return /*#__PURE__*/React.createElement(SectionMessageStyle, null, /*#__PURE__*/React.createElement(SectionMessage, {
    actions: [/*#__PURE__*/React.createElement(SectionMessageAction, {
      key: "learn more action",
      href: "https://developer.atlassian.com/platform/marketplace/new-app-categorization-system-in-marketplace/"
    }, "Learn more about app categorisation")]
  }, /*#__PURE__*/React.createElement("p", null, "To enable an efficient categorization system, we are introducing a revamped list of categories and keywords that will facilitate appropriate app discovery and frictionless navigation. Please update your app details to avoid having your app being uncategorized via ", /*#__PURE__*/React.createElement("b", null, "Manage apps"), " then ", /*#__PURE__*/React.createElement("b", null, "Select app"), " then ", /*#__PURE__*/React.createElement("b", null, "Details"), ", and then", ' ', /*#__PURE__*/React.createElement("b", null, "Categories"), ".")));
};
export default NewCategoriesSectionMessage;